export enum FeatureToggle {
  PostPurchaseMetaSiteId = 'ggAiStoreBuilderPostPurchaseMetaSiteId',
}

export const featureToggleIds: string[] = [FeatureToggle.PostPurchaseMetaSiteId];
